"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var default_text_1 = require("./default-text");

exports.HeadingText = function (props) {
  var level = props.level || 1;

  var propsClone = __assign({}, props);

  delete propsClone.level;
  return react_1.default.createElement(default_text_1.DefaultText, __assign({
    accessibilityRole: "heading",
    "aria-level": level
  }, propsClone), props.children);
};